import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { loadFonts } from '../../actions/theme';

class Theme extends Component {
    componentDidMount() {
        const { chainId, hotelId, level } = this.props;
        this.props.loadFonts(chainId, hotelId, level);
    }
    componentWillReceiveProps(nextProps) {
        if (
            this.props.level !== nextProps.level ||
            this.props.chainId !== nextProps.chainId ||
            this.props.hotelId !== nextProps.hotelId
        ) {
            nextProps.loadFonts(nextProps.chainId, nextProps.hotelId, nextProps.level);
        }
    }
    render() {
        return <div className="Theme">{this.props.children}</div>;
    }
}

Theme.propTypes = {
    children: PropTypes.element,
    loadFonts: PropTypes.func
};
const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level
    };
};

const mapDispatchToProps = dispatch => ({
    loadFonts: (chainId, hotelId, level) => dispatch(loadFonts({ chainId, hotelId, level }))
});

export default connect(mapStateToProps, mapDispatchToProps)(Theme);



// WEBPACK FOOTER //
// ./src/components/pages/Theme.js